import { render } from "./Styleguide.vue?vue&type=template&id=a58f3638"
import script from "./Styleguide.vue?vue&type=script&lang=js"
export * from "./Styleguide.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__